
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertRectified as ObiAlertRectifiedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-rectified.js';
 
 
 

 
 export const ObiAlertRectified = createComponent({
   react: React,
   tagName: 'obi-alert-rectified',
   elementClass: ObiAlertRectifiedElement,
   events: {
     
   }
  });
 
 